import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Container, Form } from "reactstrap";
import { updateServices } from "../../../../../apiServices/apiServices";
import toast from "react-hot-toast";
import { gstinPattern } from "../../../../../variables/constants";

function EditUserProfileForm(props) {
  const [editData, setEditData] = useState({
    name: props.data?.name,
    phone: props.data?.phone,
    email: props.data?.email,
    company_name: props.data?.company_name ?? "",
    user_type: props.data?.user_type,
    gst_no: props.data?.gst_no ?? "",
  });
  const [gstValid, setGstValid] = useState(true);
  const access_token = localStorage.getItem("user-access-token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (editData.gst_no && !gstValid) {
      alert("Please enter a valid GST number or remove it");
      return;
    }

    try {
      const res = await updateServices(
        `/api/authenticate/update_profile`,
        access_token,
        editData
      );
      if (res.responseCode === 200) {
        props.onClose();
        props.fetchUserDetails();
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Box
          sx={{
            maxWidth: "100%",
          }}
          className="mx-8"
        >
          <Container className="px-4 mb-4">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={
                editData.user_type == 1
                  ? "1"
                  : editData.user_type == 2
                  ? "2"
                  : ""
              }
              name="radio-buttons-group"
              className="flex !flex-row gap-7"
            >
              <FormControlLabel
                value="1"
                control={
                  <Radio
                    sx={{
                      color: "#800000",
                      "&.Mui-checked": {
                        color: "#800000",
                      },
                    }}
                    onChange={(e) => {
                      setEditData({ ...editData, user_type: e.target.value });
                    }}
                  />
                }
                label="Individual"
                sx={{
                  marginRight: "0",
                  "& .MuiTypography-root": {
                    fontFamily: "Poppins",
                  },
                }}
              />
              <FormControlLabel
                value="2"
                control={
                  <Radio
                    sx={{
                      color: "#800000",
                      "&.Mui-checked": {
                        color: "#800000",
                      },
                    }}
                    onChange={(e) => {
                      setEditData({ ...editData, user_type: e.target.value });
                    }}
                  />
                }
                label="Corporate"
                sx={{
                  marginRight: "0",
                  "& .MuiTypography-root": {
                    fontFamily: "Poppins",
                  },
                }}
              />
            </RadioGroup>
          </Container>

          <TextField
            fullWidth
            name="name"
            label="Enter a Name"
            id="fullWidth"
            type="text"
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
              "& .MuiOutlinedInput-root": {
                fontFamily: "Poppins",
                borderRadius: "12px",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#800000",
                },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#800000",
                },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #800000",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#800000",
              },
              marginBottom: "20px",
            }}
            required
            value={editData.name}
            onChange={(e) => setEditData({ ...editData, name: e.target.value })}
          />
          <TextField
            fullWidth
            name="phone"
            label="Enter a Phone No."
            id="fullWidth"
            type="tel"
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
              "& .MuiOutlinedInput-root": {
                fontFamily: "Poppins",
                borderRadius: "12px",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#800000",
                },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#800000",
                },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #800000",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#800000",
              },
              marginBottom: "20px",
            }}
            required
            onChange={(e) => {
              setEditData({ ...editData, phone: e.target.value });
            }}
            value={editData.phone}
          />
          <TextField
            fullWidth
            name="email"
            label="Enter a Email"
            id="fullWidth"
            type="email"
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
              "& .MuiInputLabel-root": {
                fontFamily: "Poppins",
              },
              "& .MuiOutlinedInput-root": {
                fontFamily: "Poppins",
                borderRadius: "12px",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#800000",
                },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#800000",
                },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #800000",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#800000",
              },
              marginBottom: "20px",
            }}
            required
            value={editData.email}
            onChange={(e) =>
              setEditData({ ...editData, email: e.target.value })
            }
          />

          {editData.user_type == 2 && (
            <TextField
              fullWidth
              name="company_name"
              label="Enter a Company name"
              id="fullWidth"
              type="company_name"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Poppins",
                },
                "& .MuiInputLabel-root": {
                  fontFamily: "Poppins",
                },
                "& .MuiOutlinedInput-root": {
                  fontFamily: "Poppins",
                  borderRadius: "12px",
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#800000",
                  },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#800000",
                  },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #800000",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#800000",
                },
                marginBottom: "20px",
              }}
              value={editData.company_name}
              onChange={(e) =>
                setEditData({ ...editData, company_name: e.target.value })
              }
            />
          )}

          {(editData.user_type == 1 || editData.user_type == 2) && (
            <TextField
              fullWidth
              name="gst_no"
              label="Enter a GST no. (e.g., 07AAAAA0000A1Z5)"
              id="fullWidth"
              type="gst_no"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Poppins",
                },
                "& .MuiInputLabel-root": {
                  fontFamily: "Poppins",
                },
                "& .MuiOutlinedInput-root": {
                  fontFamily: "Poppins",
                  borderRadius: "12px",
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#800000",
                  },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#800000",
                  },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #800000",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#800000",
                },
                marginBottom: "20px",
              }}
              value={editData.gst_no}
              onChange={(e) => {
                // Auto-convert to uppercase
                const upperValue = e.target.value.toUpperCase();
                setEditData({ ...editData, gst_no: upperValue });

                // Validate
                if (upperValue.trim().length === 0) {
                  setGstValid(true);
                } else {
                  setGstValid(gstinPattern.test(upperValue.trim()));
                }
              }}
            />
          )}

          <Container className="flex justify-end items-center mb-5">
            <Button
              type="submit"
              className="px-8 py-2 bg-[#800000] text-white font-semibold rounded-lg active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
            >
              Update Profile
            </Button>
          </Container>
        </Box>
      </Form>
    </Container>
  );
}

export default EditUserProfileForm;
